import { useState, useEffect } from 'react'

// Date.now(), refreshed every `ms` -- for the running capsules' timers.
export function useReloj(ms = 15000) {
  const [ahora, setAhora] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setAhora(Date.now()), ms)
    return () => clearInterval(id)
  }, [ms])
  return ahora
}
